import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/icon-right-white.png'
import _imports_1 from '../../assets/images/icon-right-red.png'


const _withScopeId = n => (_pushScopeId("data-v-67348e18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-100 pb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "d-sm-flex align-items-center justify-content-between mb-50 position-relative z-1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title left-title mb-0",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "200"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "top-title" }, "CAPABILITIES"),
  /*#__PURE__*/_createElementVNode("h4", { title: "We connect brands with celebrities and influencers for powerful digital campaigns." }, " MyCelebrity offers a range of services to help brands leverage celebrity and influencer for marketing and promotions. ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "right-chevron"
}, null, -1))
const _hoisted_6 = {
  class: "row justify-content-center g-4",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "300"
}
const _hoisted_7 = { class: "capabilities-single-item transition-y d-flex flex-column h-100" }
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { title: "We connect brands with celebrities and influencers for powerful digital campaigns." }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
  src: _imports_1,
  alt: "icon-right-red"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-style pt-75" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          to: "/services",
          class: "default-btn btn-two mt-3 mt-sm-0",
          "data-aos": "fade-up",
          "data-aos-duration": "1200",
          "data-aos-delay": "200"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" VIEW ALL SERVICES "),
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.capabilities, (capabilitie) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-lg-4 col-md-6",
            key: capabilitie.id
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: capabilitie.imageIcon,
                  alt: "icon"
                }, null, 8, _hoisted_9)
              ]),
              _createElementVNode("h3", _hoisted_10, _toDisplayString(capabilitie.title), 1),
              _createElementVNode("p", null, _toDisplayString(capabilitie.description), 1),
              _createVNode(_component_router_link, {
                to: capabilitie.link,
                class: "read-more mt-auto"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" READ MORE "),
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]))
        }), 128))
      ]),
      _hoisted_12
    ])
  ]))
}